/**
 * Replace any residual `{{ref}}` result token the server didn't substitute with a
 * visible `[?]` marker — never literal braces, never a silent gap that reads as a
 * dropped word. A signal QA can catch if the token-substitution contract drifts.
 */
export const stripResidualTokens = (text: string): string =>
  text.replace(/\{\{\s*[a-zA-Z0-9_.]+\s*\}\}/g, '[?]')
